import React from 'react';
const ClientLogos = () => {
  const logos = [{
    name: 'CVS Health',
    url: 'https://uploadthingy.s3.us-west-1.amazonaws.com/ePKfoGgmweyvuY4gJA32dL/CVS_Health_Logo.svg.png'
  }, {
    name: 'Mastercard',
    url: 'https://upload.wikimedia.org/wikipedia/commons/thumb/2/2a/Mastercard-logo.svg/1280px-Mastercard-logo.svg.png'
  }, {
    name: 'IBM',
    url: 'https://uploadthingy.s3.us-west-1.amazonaws.com/vWuzyrzQkJV6oWJCiobh1q/IBM_logo.png'
  }, {
    name: 'Integral',
    url: 'https://uploadthingy.s3.us-west-1.amazonaws.com/g7YRzbDhjfPgTGFpPK88Kc/Integral_Teal-scaled.png'
  }, {
    name: 'Ralph Lauren',
    url: 'https://uploadthingy.s3.us-west-1.amazonaws.com/rP36TQdaeLFnYeFMVpfjiy/Ralph_Lauren_Corporation-Logo.wine.png'
  }];
  return <section className="py-8 md:py-12 bg-lightgray bg-opacity-30" data-id="element-45">
      <div className="container mx-auto px-4 md:px-12" data-id="element-46">
        <div className="grid grid-cols-2 md:grid-cols-5 gap-8 md:gap-12 items-center" data-id="element-47">
          {logos.map((logo, index) => <div key={index} className="flex justify-center items-center" data-id="element-48">
              <img src={logo.url} alt={`${logo.name} logo`} className={`${logo.name === 'Ralph Lauren' ? 'h-20 md:h-28' : 'h-10 md:h-14'} w-auto object-contain grayscale opacity-70 hover:opacity-100 transition-opacity duration-300`} data-id="element-49" />
            </div>)}
        </div>
      </div>
    </section>;
};
export default ClientLogos;